import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef } from "react";
import styled from "styled-components";
import CopyButton from "../../../r2components/CopyButton";

const TerminalContainer = styled.div`
  border-radius: 10px;
`;

const TerminalHeader = styled.div`
  background: black;
  padding: var(--global-spacing-m);
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid var(--global-dark-gray);
`;

const Contents = styled.div`
  background: black;
  padding: var(--global-spacing-m);
  border-radius: 0 0 10px 10px;
`;

const CodelineContainer = styled.div`
  margin: var(--global-spacing-s);
  margin-bottom: var(--global-spacing-l);
  font-family: var(--global-font-family-monospace);
`;

const Comment = styled.span`
  color: var(--dark-button-indigo);
`;

const Command = styled.span`
  color: var(--global-off-white);
`;

const FAIcon = styled(FontAwesomeIcon)`
  margin-right: 7px;
`;

const CodeLine: React.FC<{ comment: string; command: string }> = ({
  comment,
  command,
}) => {
  const codeRef = useRef(null);
  return (
    <CodelineContainer>
      <Comment>{`# ${comment}`}</Comment>
      <br />
      <Command>
        $ <span ref={codeRef}>{command}</span>
      </Command>
      <CopyButton
        style={{ marginLeft: "var(--global-spacing-m)" }}
        getTarget={() => codeRef.current}
      />
    </CodelineContainer>
  );
};

export const InstallInstructions: React.FC<{}> = () => {
  return (
    <TerminalContainer>
      <TerminalHeader>
        <FAIcon style={{ color: "#e64135" }} icon={faCircle} />
        <FAIcon icon={faCircle} color="orange" />
        <FAIcon style={{ color: "var(--global-green)" }} icon={faCircle} />
      </TerminalHeader>
      <Contents>
        <CodeLine comment="For macOS" command="brew install semgrep" />
        <CodeLine
          comment="For Ubuntu/WSL/Linux/macOS"
          command="python3 -m pip install semgrep"
        />
        <CodeLine
          comment="To try Semgrep without installation run via Docker"
          command={`docker run --rm -v "$\{PWD}:/src" returntocorp/semgrep --config=auto`}
        />
        <CodeLine
          comment="Run recommended rules (covering many languages) on your code!"
          command="semgrep --config=auto path/to/src"
        />
      </Contents>
    </TerminalContainer>
  );
};
